import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { TestataIntervento } from '../../models/Intervento';
import { PopoverController } from '@ionic/angular';
import { PopoverInterventoComponent } from '../popover-intervento/popover-intervento.component';
import { PopoverInterventoAutomezziComponent } from '../popover-intervento-automezzi/popover-intervento-automezzi.component';
import { PreferencesService } from '../../sharedServices/preferences/preferences.service';
import { PreferenzeApp } from '../../models/Preferenze';

@Component({
  selector: 'app-header-intervento',
  templateUrl: './header-intervento.component.html',
  styleUrls: ['./header-intervento.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class HeaderInterventoComponent implements OnInit {
  @Input() model: TestataIntervento;
  @Input() isInCompilazione: boolean;
  @Input() isAnteprima: boolean;

  preferenze: PreferenzeApp;

  constructor(
    private popoverController: PopoverController,
    private preferencesService: PreferencesService
  ) { }

  async ngOnInit() {
    this.preferenze = await this.preferencesService.getPreferenzeUtente();
  }

  async presentPopover(ev: any, isCliente: boolean) {
    const popover = await this.popoverController.create({
      component: PopoverInterventoComponent,
      event: ev,
      translucent: true,
      componentProps: {
        model: isCliente ? this.model : this.model.destinazione,
        isCliente
      },
      cssClass: 'modal-medio-piccola'
    });
    return await popover.present();
  }

  async presentPopoverAutomezzi(ev: any) {
    const popover = await this.popoverController.create({
      component: PopoverInterventoAutomezziComponent,
      event: ev,
      translucent: true,
      componentProps: {
        automezzi: this.model.automezziPrenotati || []
      },
      cssClass: 'modal-medio-piccola'
    });
    return await popover.present();
  }

  get truncatedDescription() {
    // Controlla se la descrizione esiste altrimenti rimanda "--"
    if (!this.model.descrizioneCommessa || this.model.descrizioneCommessa.trim() === '') {
        return '--';
    }

    /**
     * Se la descrizione ha più di tot caratteri e è in anteprima, tronca e restituisce,
     * altrimenti restituisci la descrizione completa
     */
    return this.model.descrizioneCommessa.length > 30 && this.isAnteprima
        ? this.model.descrizioneCommessa.substring(0, 30) + '...' 
        : this.model.descrizioneCommessa;
  }

}
